export default __webpack_public_path__ + "static/media/conceitos-respons.241ec113.png";